import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const GroupNameContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  px: { sm: '200' },
  py: { sm: '100' },
})`
  ${({ theme }) => css`
    margin-top: -${theme.spacings[200]};
    border-radius: ${theme.radii[800]};
    background-color: ${theme.colors.grey[100]};
    position: absolute;
    bottom: -${theme.spacings[100]};
  `}
`;
